// extracted by mini-css-extract-plugin
export default {"slider":"slider","track":"track","track-0":"track-0","track0":"track-0","thumb":"thumb","thumb-label":"thumb-label","thumbLabel":"thumb-label","last":"last","mark":"mark"};